import { useEffect } from 'react';
import { useHeadScripts } from '@/hooks/useHeadScripts';

export function HeadScriptInjector() {
  const { activeScripts } = useHeadScripts();

  useEffect(() => {
    if (!activeScripts || activeScripts.length === 0) return;

    // Limpar scripts antigos injetados dinamicamente
    const existingScripts = document.querySelectorAll('[data-dynamic-head-script]');
    existingScripts.forEach(script => script.remove());

    // Injetar novos scripts
    activeScripts.forEach((script) => {
      // Criar elemento temporário para parsear o HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = script.script_content.trim();

      // Iterar sobre os elementos (podem ser múltiplos scripts, links, etc.)
      Array.from(tempDiv.children).forEach((element) => {
        const newElement = element.cloneNode(true) as HTMLElement;
        
        // Marcar elemento como dinamicamente injetado
        newElement.setAttribute('data-dynamic-head-script', script.id);
        
        // Se for script, precisamos recriar para que execute
        if (element.tagName === 'SCRIPT') {
          const scriptElement = document.createElement('script');
          scriptElement.setAttribute('data-dynamic-head-script', script.id);
          
          // Copiar atributos
          Array.from(element.attributes).forEach(attr => {
            scriptElement.setAttribute(attr.name, attr.value);
          });
          
          // Copiar conteúdo inline
          if (element.textContent) {
            scriptElement.textContent = element.textContent;
          }
          
          document.head.appendChild(scriptElement);
        } else {
          // Para outros elementos (link, meta, etc.)
          document.head.appendChild(newElement);
        }
      });
    });

    // Cleanup ao desmontar
    return () => {
      const scripts = document.querySelectorAll('[data-dynamic-head-script]');
      scripts.forEach(script => script.remove());
    };
  }, [activeScripts]);

  return null;
}
